import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungOldenburg() {
  return (
    <CityPageTemplate
      city="Oldenburg"
      slug="oldenburg"
      intro="Oldenburg als Universitäts- und Wirtschaftsstadt in Niedersachsen – smarte Finanzberatung ohne Banktermin."
      description="Unabhängige & digitale Finanzberatung für Oldenburg: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
